export const LIVIS_API_BASE_URL = process.env.REACT_APP_LIVIS_API_URL;
export const SSE_ENABLE = process.env.REACT_APP_IS_SSE;
export const UPLOAD_URL = process.env.REACT_APP_UPLOAD_API_URL;
export const DEPLOYMENT_TYPE = process.env.REACT_APP_DEPLOYMENT;

//If you are adding a new variable make sure to add REACT_APP prefix , also make sure to export from index.ts - config/index.ts
